import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CloudPremisePlugin, useAuthProvider } from "@cloudpremise/portal_core";
import { routes, menus, userMenus, footerMenus, settingMenus } from "./src";
import Config from "../../Config";
import { FileManager } from "./src/types";
import packageJson from "./package.json";
import { S3 } from 'aws-sdk';


const FileManagerPlugin = new FileManager ({
    name: packageJson.name,
    description: packageJson.description,
    status: packageJson.status,
    routes: routes,
    menus: menus,
    userMenus: userMenus,
    footerMenus: footerMenus,
    settingMenus: settingMenus,
    s3Client: null,
    render: (props: any) => {
        return null
    },
    onConfig(plugin: CloudPremisePlugin) {
        try{
            let config = JSON.parse(decodeURIComponent(plugin.Configuration__c));
            if(typeof(config) === "object" && config.hasOwnProperty("awsS3") && config.awsS3.hasOwnProperty("status") && config.awsS3.status){
                const awsS3Config = config.awsS3;
                Config['REACT_APP_S3_REGION'] = awsS3Config.region;
                Config['REACT_APP_S3_BUCKET'] = awsS3Config.bucket;
                Config['REACT_APP_S3_ACCESS_KEY'] = awsS3Config.accessKey;
                Config['REACT_APP_S3_ACCESS_SECRET'] = awsS3Config.accessSecret;
                Config['REACT_APP_S3_DEFAULT_PATH'] = awsS3Config.defaultPath;
            }
            if(typeof(config) === "object"){
                this.config = config;
            }
        }catch(e){ console.log(e); }
    },
    getAwsClient(){
        if(this.s3Client !== null && typeof(this.s3Client) !== "undefined"){
            return this.s3Client;
        }
        const config = this.config;
        if(typeof(config) === "object" && config.hasOwnProperty("awsS3") && config.awsS3.hasOwnProperty("status") && config.awsS3.status){
            const awsS3Config = config.awsS3;
            this.s3Client = new S3({
                region: awsS3Config.region,
                accessKeyId: awsS3Config.accessKey,
                secretAccessKey: awsS3Config.accessSecret,
            });
        }
        return this.s3Client;
    }
});

export default FileManagerPlugin;